import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { app } from './azuread';
import { LicenseInfo } from '@material-ui/x-grid';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MATERIAL_X_LICENSE!);

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={app}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
